export const IMPORTANT_ORDER_DETAILS_KEYS = ['parcel id', 'property (situs) address', 'legal description', 'situs address']

export const SCRAPPER_STATES = {
  RUNNING: 'running',
  SUCCESS: 'success',
  FAILED: 'failed',
  NA: 'N/A',
  NOT_AVAILABLE: 'not_available'
}

export const SCRAPER_STATUSES = {
  [SCRAPPER_STATES.RUNNING]: 'Retrieving',
  [SCRAPPER_STATES.SUCCESS]: 'Retrieved successfully',
  [SCRAPPER_STATES.FAILED]: 'Retrieval failed',
  [SCRAPPER_STATES.NA]: 'Retrieval not started',
  [SCRAPPER_STATES.NOT_AVAILABLE]: 'Not available'
}

// product names for which a different UI is needed in the add/edit order modal
export const PRODUCT_NAMES = ['PPS Update', 'Prior Policy Search']

export const RUNSHEET_TABS = {
  RUNSHEET: {
    VALUE: 'RECORDER',
    LABEL: 'Runsheet'
  },
  COURT: {
    VALUE: 'COURT',
    LABEL: 'Court'
  },
  TAX: {
    VALUE: 'TAX',
    LABEL: 'Tax'
  },
  ASSESSOR: {
    VALUE: 'ASSESSOR',
    LABEL: 'Assessor'
  }
}

export const SITE_TYPE = {
  COURT: 'court',
  TAX: 'tax',
  ASSSESSOR: 'assessor',
  RECORDER: 'recorder'
}

export const COURT_SITE_MAPPING = {
  'Civil Court Cases': 'Civil Court',
  'Family Court Cases': 'Family Court',
  'Probate Court Cases': 'Probate Court'
}

export const COURT_CASE_TABLE_COLUMNS_ORDER = {
  'case_type': 4,
  'party_name': 2,
  'case_number': 1,
  'court': 0,
  'filing_date': 3
}

export const ASSESSOR_TABLE_COLUMNS_ORDER = {
  'apn': 1,
  'owner': 2,
  'address': 3
}
